import { defineAsyncComponent } from 'vue';
import legoIconWrapper from './legoIconWrapper.vue';
import legoIcon from './legoIcon.vue';

export default {
  install(Vue) {
    Vue.component(legoIcon.name, legoIcon);
    Vue.component(legoIconWrapper.name, legoIconWrapper);
  },
};
